import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import OSM, {ATTRIBUTION} from 'ol/source/OSM';
import Feature from 'ol/Feature';
import {	Point, LineString} from 'ol/geom';
import {Icon, Style, Stroke, Fill, Text} from 'ol/style';
import {	fromLonLat, 	get} from 'ol/proj';
import {ScaleLine, defaults as defaultControls} from 'ol/control';

// default zoom, center
let zoom = 2;
let center = [0, 0];
let track = [];
let pins = [];

// Limit multi-world panning to one world east and west of the real world.
// Geometry coordinates have to be within that range.
const extent = get('EPSG:3857').getExtent().slice();
extent[0] += extent[0];
extent[2] += extent[2];

// find params in the URL
var query = window.location.search.substring(1);
var vars = query.split("&");
for (var j=0;j<vars.length;j++) {
    var pair = vars[j].split("=");
    switch (pair[0]) {
    	case "z" : zoom = pair[1]; break;
    	case "c" : var c = pair[1].split('/'); center = fromLonLat([parseFloat(c[1]), parseFloat(c[0])]); break;
    	case "t" : 	var t = pair[1].split('/');
    			for (var i=1;i<t.length;i+=2) {
    				track.push(fromLonLat([parseFloat(t[i]), parseFloat(t[i-1])]));
    			}
    			break;
    case "p" : 	var p = pair[1].split('/');
    			for (var i=1;i<p.length;i+=2) {
    				pins.push(fromLonLat([parseFloat(p[i]), parseFloat(p[i-1])]));
    			}
    			break;
    }
} 


// build drawings for vector layer
const myfeatures = new Array();




// track path
if (track.length > 1) { 
	const path = new Feature({
		geometry: new LineString(track),
	});
	path.setStyle(
		new Style({
			stroke: new Stroke({
      				color: 'rgba(148, 0, 211, .7)',
     				width: 6,
     				lineDash : [25, 15]
    			}),
		})
	);
	myfeatures.push(path);
}

// start point
if (track.length > 0) { 
	const start = new Feature({
		geometry: new Point(track[0]),
	});
	start.setStyle(
		new Style({
			image: new Icon({
				anchor: [0.3,0.95],
				crossOrigin: 'anonymous',
				src: 'images/start.png',
			}),
		})
	);
	myfeatures.push(start);
}

// finish point
if (track.length > 1) { 
	const finish = new Feature({
		geometry: new Point(track[track.length-1]),
	});
	finish.setStyle(
		new Style({
			image: new Icon({
				anchor: [0.1,0.95],
				crossOrigin: 'anonymous',
				src: 'images/finish.png',
			}),
		})
	);
	myfeatures.push(finish);
}

// pins points
if (pins.length == 1)
{
    var feature = new Feature({
		geometry: new Point(pins[0]),
	});
	feature.setStyle(
		new Style({
		    image: new Icon({
				anchor: [0.3,0.95],
				crossOrigin: 'anonymous',
				src: 'images/pin-6.png'
			})
		})
	);
	myfeatures.push(feature);
}
else if (pins.length > 0)
{
    var k=1;
    const pinurl = 'images/pin-';
    for (const pin of pins) {
        var feature = new Feature({
		    geometry: new Point(pin),
	    });
	    feature.setStyle(
		    new Style({
		            image: new Icon({
				    anchor: [0.3,0.95],
				    crossOrigin: 'anonymous',
				    src: pinurl.concat((k%10).toString(), '.png')
			    }),
		        text: new Text({
                    text: k.toString(),
                    font: 'bold 28px sans-serif',
                    fill: new Fill({
                        color: 'black',
                    }),
                    stroke: new Stroke({
                        color: 'white',
                        width: 4,
                    }),
                    textBaseline: 'top',
                    offsetY: 4
                })
		    })
		);
		myfeatures.push(feature);
		k++;
    }
}


/* -------- */

const vectorSource = new VectorSource({
	features: myfeatures,
});

const vectorLayer = new VectorLayer({
	source: vectorSource,
});

const raster = new TileLayer({
  source: new OSM({
    attributions: [
      '<a href="https://carto.lepetitsite.com/tuto" target="_blank">carto.lepetitsite.com</a> | <a href="https://openlayers.org/" target="_blank">openlayers.org</a> | ',
      ATTRIBUTION,
    ],}),
});

const map = new Map({
  target: 'map',
  controls: defaultControls().extend([
  				new ScaleLine({units: 'metric'})
  				]),
  layers: [raster, vectorLayer],
  view: new View({
    center: center,
    zoom: zoom,
    extent: extent
  })
});
